import { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { ReducerContext } from 'App'

export const useConfig = () => {
  const {
    state: { config },
    dispatch
  } = useContext(ReducerContext)
  const [loading, setLoading] = useState(!config.loaded)

  useEffect(() => {
    if (!config.loaded) {
      axios
        .get(`${localStorage.getItem('LOGITRAC_API_URL')}api/config`)
        .then(response => {
          dispatch({
            type: 'UPDATE_CONFIG',
            payload: { ...response.data, loaded: true }
          })
          setLoading(false)
        })
        .catch(error => {
          console.error('Failed to load config:', error)
          setLoading(false)
        })
    }
  }, [config.loaded, dispatch])

  return { config, loading }
}

export const useS3Upload = () => {
  const { config } = useConfig()
  const uploadToS3 = async file => {
    try {
      const apiUrl = config.LOGITRAC_API_URL
      const { data } = await axios.post(`${apiUrl}api/proxy/s3-upload`, {
        fileName: file.name,
        contentType: file.type
      })

      await fetch(data.uploadUrl, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': file.type
        }
      })

      return data.publicUrl
    } catch (error) {
      console.error('S3 upload failed:', error)
      throw error
    }
  }

  return { uploadToS3 }
}
